/* Scent wheel renderer (design handoff explorations 1a labelled / 1f mini).
   Liquid resolves the taxonomy + product into a JSON block inside a
   [data-eoc-scent-wheel] host and renders the SVG shell (centre text, caption,
   aria); this script draws the rings. Same pattern as the EC terpene wheel.
   Arc math is the reference ring() / arcPath() / pt() verbatim. Quadrant
   boundaries sit on the axes and the families run clockwise from 12 as
   Floral, Amber, Woody, Fresh, matching the EOC Fragrance Wheel artwork.

   A product is not one point on the wheel. data.weights carries every facet its
   notes touch with a note count, so each touched facet is drawn at full ring
   thickness with its opacity scaled to its share of them.
   With no weights the renderer falls back to lighting the single
   data.facet, which is what the fixture handles still do. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var GEOM = {
    labelled: { c: 140, fam: [60, 86], fac: [90, 116], lit: 120, lbl: 126, lblBottom: 133, lead: [122, 160], ops: { fam: 0.25, same: 0.45, other: 0.1 } },
    mini: { c: 100, fam: [42, 62], fac: [66, 92], lit: 98, ops: { fam: 0.22, same: 0.42, other: 0.12 } }
  };
  /* Petals fill the ring at full colour, as the PDF's blend diagrams do - the
     unlit ring behind them is a faint tint, so presence reads instantly. The
     strongest facet also takes a plum dot, the marker the PDF uses. */
  var PETAL = { minOpacity: 0.82 };

  function pt(cx, cy, r, deg) { var a = deg * Math.PI / 180; return [cx + r * Math.sin(a), cy - r * Math.cos(a)]; }
  function f2(n) { return Math.round(n * 100) / 100; }
  function ring(cx, cy, r0, r1, a0, a1) {
    var p1 = pt(cx, cy, r1, a0), p2 = pt(cx, cy, r1, a1), p3 = pt(cx, cy, r0, a1), p4 = pt(cx, cy, r0, a0);
    var lg = a1 - a0 > 180 ? 1 : 0;
    return 'M' + f2(p1[0]) + ' ' + f2(p1[1]) + ' A' + r1 + ' ' + r1 + ' 0 ' + lg + ' 1 ' + f2(p2[0]) + ' ' + f2(p2[1]) + ' L' + f2(p3[0]) + ' ' + f2(p3[1]) + ' A' + r0 + ' ' + r0 + ' 0 ' + lg + ' 0 ' + f2(p4[0]) + ' ' + f2(p4[1]) + ' Z';
  }
  function arcPath(cx, cy, r, a0, a1, reverse) {
    var s = pt(cx, cy, r, reverse ? a1 : a0), e = pt(cx, cy, r, reverse ? a0 : a1);
    var lg = Math.abs(a1 - a0) > 180 ? 1 : 0;
    return 'M' + f2(s[0]) + ' ' + f2(s[1]) + ' A' + r + ' ' + r + ' 0 ' + lg + ' ' + (reverse ? 0 : 1) + ' ' + f2(e[0]) + ' ' + f2(e[1]);
  }
  function el(tag, attrs, style, text) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    if (style) e.setAttribute('style', style);
    if (text != null) e.textContent = text;
    return e;
  }
  function link(href, label, child, hover) {
    var a = el('a', { href: href, 'aria-label': label }); a.appendChild(child);
    if (hover) {
      a.addEventListener('mouseenter', hover.enter); a.addEventListener('focus', hover.enter);
      a.addEventListener('mouseleave', hover.leave); a.addEventListener('blur', hover.leave);
    }
    return a;
  }

  /* weights -> lookup by facet handle, plus the strongest count and per-family totals */
  function weigh(data) {
    var w = { by: {}, notes: {}, max: 0, total: data.total || 0, fam: {}, famMax: 0 };
    if (!data.weights || !data.weights.length) return w;
    data.weights.forEach(function (x) {
      if (!x || !x.handle || !x.count) return;
      w.by[x.handle] = x.count;
      w.notes[x.handle] = x.notes || '';
      if (x.count > w.max) w.max = x.count;
    });
    if (!w.total) { for (var k in w.by) w.total += w.by[k]; }
    (data.families || []).forEach(function (f) {
      var n = 0;
      (f.facets || []).forEach(function (x) { n += w.by[x.handle] || 0; });
      w.fam[f.handle] = n;
      if (n > w.famMax) w.famMax = n;
    });
    return w;
  }

  /* Centre readout: hover / focus a segment and the centre names it and says how
     it relates to this oil. A facet this oil actually occupies reports its share
     of the notes; the rest report kindred (neighbouring family) or complementary
     (the family opposite). Leaving restores the product's own text. */
  function readout(svg, cls, data, w) {
    var famEl = svg.querySelector('.' + cls + '__fam'), subEl = svg.querySelector('.' + cls + '__season');
    if (!famEl || !subEl) return null;
    var orig = { fam: famEl.textContent, sub: subEl.textContent }, myRing = -1;
    data.families.forEach(function (f) { if (f.handle === data.family) myRing = f.ring; });
    function relation(f, facet) {
      var n = facet ? (w.by[facet.handle] || 0) : 0;
      if (n) return w.notes[facet.handle] || (n + (n === 1 ? ' note' : ' notes') + ' here');
      if (f.handle === data.family) return 'same family as this oil';
      var d = ((f.ring - myRing) % 4 + 4) % 4;
      return d === 2 ? 'complementary · adds contrast' : 'kindred · blends in harmony';
    }
    return {
      enter: function (f, facet) {
        return function () {
          var has = facet && (w.by[facet.handle] || 0);
          famEl.textContent = facet ? (has ? facet.label + ' Notes' : facet.label) : f.label;
          famEl.classList.toggle(cls + '__fam--facet', !!facet);
          subEl.textContent = relation(f, facet);
        };
      },
      leave: function () { famEl.textContent = orig.fam; famEl.classList.remove(cls + '__fam--facet'); subEl.textContent = orig.sub; }
    };
  }


  /* ---------------------------------------------------------------- markers
     One disc per note: the note's picture where we have one, otherwise its
     initial on the facet's colour. Hovering or focusing a disc names the note.
     The tooltip is an HTML element positioned in percentages of the viewBox, so
     it follows the disc at any rendered size. */

  /* ------------------------------------------------------------ material marks
     Every note draws itself: lemon is a lemon, lime is a lime, clove is a clove
     bud. Sixty notes, sixty marks. Ink line art (component-scent.css sets the
     stroke to --sc-text) on a tint of the facet colour, built from primitives
     in a 24x24 box (centre 12,12) and scaled into the disc. The stroke is
     deliberately not the facet colour: markers sit on the lit facet, which is
     filled at full colour, and a same-hue glyph vanished into it.

     Each mark is a handful of strokes on purpose. They render around 18px on
     the wheel, where the silhouette carries recognition and detail turns to
     mud; the hover label is what names the note exactly. A note with no entry
     falls back to its facet's shape, so nothing renders blank. */
  function C(cx, cy, r, extra) { return { t: 'circle', a: mix({ cx: cx, cy: cy, r: r }, extra) }; }
  function L(x1, y1, x2, y2) { return { t: 'line', a: { x1: x1, y1: y1, x2: x2, y2: y2 } }; }
  function P(d) { return { t: 'path', a: { d: d } }; }
  function E(cx, cy, rx, ry, rot) {
    return { t: 'ellipse', a: { cx: cx, cy: cy, rx: rx, ry: ry, transform: rot == null ? null : 'rotate(' + rot + ')' } };
  }
  function mix(a, b) { if (b) { for (var k in b) a[k] = b[k]; } return a; }
  function dash(v) { return { 'stroke-dasharray': v }; }
  function star(pointCount, r1, r2, cx, cy) {
    cx = cx == null ? 12 : cx; cy = cy == null ? 12 : cy;
    var d = '', i, a, r;
    for (i = 0; i < pointCount * 2; i++) {
      a = (Math.PI * i) / pointCount - Math.PI / 2;
      r = i % 2 ? r2 : r1;
      d += (i ? 'L' : 'M') + (cx + r * Math.cos(a)).toFixed(1) + ' ' + (cy + r * Math.sin(a)).toFixed(1);
    }
    return P(d + 'Z');
  }
  /* n petals around (cx,cy), each an ellipse pushed out by dist and rotated home */
  function petals(n, rx, ry, dist, cx, cy, off) {
    cx = cx == null ? 12 : cx; cy = cy == null ? 12 : cy; off = off || 0;
    var out = [], i;
    for (i = 0; i < n; i++) {
      out.push({
        t: 'ellipse',
        a: { cx: cx, cy: cy - dist, rx: rx, ry: ry, transform: 'rotate(' + (off + (i * 360) / n).toFixed(1) + ' ' + cx + ' ' + cy + ')' }
      });
    }
    return out;
  }
  function rays(n, r0, r1, cx, cy) {
    cx = cx == null ? 12 : cx; cy = cy == null ? 12 : cy;
    var out = [], i, a;
    for (i = 0; i < n; i++) {
      a = (Math.PI * 2 * i) / n - Math.PI / 2;
      out.push(L(+(cx + r0 * Math.cos(a)).toFixed(1), +(cy + r0 * Math.sin(a)).toFixed(1),
                 +(cx + r1 * Math.cos(a)).toFixed(1), +(cy + r1 * Math.sin(a)).toFixed(1)));
    }
    return out;
  }
  function join() {
    var out = [], i, j, x;
    for (i = 0; i < arguments.length; i++) {
      x = arguments[i];
      if (x && x.length !== undefined && x.t === undefined) { for (j = 0; j < x.length; j++) { out.push(x[j]); } }
      else { out.push(x); }
    }
    return out;
  }

  var NOTE_MARK = {
    /* ---- citrus: told apart by outline, not by the slice inside ---- */
    lemon: function () { return [E(12, 12, 4.6, 6.2), L(12, 5.6, 12, 3.9), L(12, 18.4, 12, 20.1)]; },
    lime: function () { return [C(12, 12.6, 5.2), L(12, 7.4, 12, 17.8), L(6.8, 12.6, 17.2, 12.6)]; },
    orange: function () { return [C(12, 13, 5.7), P('M12 7.3c1.5-1.7 3.4-2.2 4.7-1.5-.4 1.9-1.9 3-3.6 3')]; },
    grapefruit: function () { return [C(12, 12, 6.6), L(12, 5.4, 12, 18.6), L(6.3, 8.7, 17.7, 15.3), L(6.3, 15.3, 17.7, 8.7)]; },
    bergamot: function () { return [E(12, 13.6, 4.7, 5.1), E(12, 8.8, 3.1, 2.9), L(12, 5.7, 12, 4.1)]; },
    citrus: function () { return [P('M5.2 14.4a6.8 6.8 0 0 1 13.6 0z'), L(12, 14.4, 12, 7.6), L(12, 14.4, 6.8, 11.2), L(12, 14.4, 17.2, 11.2)]; },

    /* ---- orchard, vine and tropical fruit ---- */
    'berry-red-fruits': function () { return [C(9.6, 14.6, 2.9), C(14.4, 14.6, 2.9), C(12, 10, 2.9), L(12, 7.1, 13.6, 5)]; },
    fruity: function () { return join(C(9.4, 15.6, 2.2), C(14.6, 15.6, 2.2), C(12, 12.2, 2.2), C(7.6, 11.6, 2.2), C(16.4, 11.6, 2.2), L(12, 10, 12.8, 6.2)); },
    apple: function () { return [P('M12 8.6c-2.7 0-4.6 2-4.6 4.7 0 3 2.3 5.4 4.6 5.4s4.6-2.4 4.6-5.4c0-2.7-1.9-4.7-4.6-4.7z'), L(12, 8.6, 12, 5.6), P('M12 6.6c1.3-.9 2.6-.7 3.4.2-.9 1.1-2.2 1.3-3.4.7z')]; },
    pear: function () { return [P('M12 7.4c-1 0-1.7.7-1.7 1.6 0 1.4-3 2.6-3 5.6 0 2.7 2.1 4.7 4.7 4.7s4.7-2 4.7-4.7c0-3-3-4.2-3-5.6 0-.9-.7-1.6-1.7-1.6z'), L(12, 7.4, 12, 4.8)]; },
    'peach-apricot': function () { return [C(12, 12.8, 5.4), P('M12 7.5c-1.4 2.3-1.4 8.3 0 10.6'), P('M12.4 7.4c1.2-1.2 2.6-1.5 3.6-1-.4 1.4-1.5 2.2-2.8 2.2')]; },
    melon: function () { return [C(12, 12, 6), P('M6.2 10.2q5.8 2.6 11.6 0'), P('M6.2 13.8q5.8-2.6 11.6 0'), L(12, 6, 12, 18)]; },
    tropical: function () { return join(E(12, 14.6, 4.3, 4.9), L(9.4, 11.8, 14.6, 17.4), L(14.6, 11.8, 9.4, 17.4), L(12, 9.7, 12, 5.2), L(12, 9.7, 9.2, 6.2), L(12, 9.7, 14.8, 6.2)); },
    coconut: function () { return [C(12, 12.4, 5.6), C(10.1, 10.7, 0.8), C(13.7, 10.5, 0.8), C(11.9, 13.6, 0.8)]; },
    pumpkin: function () { return [C(12, 13.2, 5.3), P('M9.4 8.6q-1.4 4.6 0 9.2'), P('M14.6 8.6q1.4 4.6 0 9.2'), L(12, 7.9, 12, 5.6)]; },

    /* ---- florals ---- */
    floral: function () { return join(petals(5, 2.1, 3.2, 3.6), C(12, 12, 1.7)); },
    rose: function () { return [P('M13.7 12a1.7 1.7 0 1 0-1.7-1.7'), P('M15.5 12.4a3.5 3.5 0 1 1-3.5-3.5'), P('M17.7 12.6a5.7 5.7 0 1 1-5.7-5.7')]; },
    'jasmine-white-florals': function () { return join(petals(4, 1.6, 4.2, 3.4), C(12, 12, 1.3)); },
    'lily-of-the-valley': function () { return [P('M13.8 19.6c0-6.2.8-10.6 2.6-13.6'), C(12.5, 10.4, 2.1), C(10.7, 14.2, 2.1), C(9.7, 18, 2.1)]; },
    geranium: function () { return join(L(12, 19.4, 12, 12.2), C(9.7, 9, 1.9), C(14.3, 9, 1.9), C(12, 6.6, 1.9), C(12, 11, 1.9), E(9, 15.6, 2.6, 1.6, '-30 9 15.6')); },
    neroli: function () { return join(petals(5, 1.8, 2.7, 3.1, 12, 10.4), C(12, 10.4, 1.4), L(12, 14, 12, 19.2), E(14.6, 16.4, 2.4, 1.5, '25 14.6 16.4')); },
    violet: function () { return join(petals(5, 2, 2.8, 3.2, 12, 10.6, 25), C(12, 10.6, 1.2), P('M12 14.2q.6 3.4 3.6 5.2')); },
    'ylang-ylang': function () { return [P('M12 9.6q-4.4 1.2-6.6 6.4'), P('M12 9.6q-1.6 3.6-.8 8.6'), P('M12 9.6q1.6 3.6.8 8.6'), P('M12 9.6q4.4 1.2 6.6 6.4'), C(12, 8.4, 1.8)]; },

    /* ---- herbs and green ---- */
    herbal: function () { return join(L(12, 19.2, 12, 5.6), E(9.4, 8.6, 2.5, 1.5, '-35 9.4 8.6'), E(14.6, 10.2, 2.5, 1.5, '35 14.6 10.2'), E(9.4, 12.2, 2.5, 1.5, '-35 9.4 12.2'), E(14.6, 13.8, 2.5, 1.5, '35 14.6 13.8')); },
    lavender: function () { return join(L(12, 19.4, 12, 11), E(10.6, 9.6, 1.3, 2, '-18 10.6 9.6'), E(13.4, 9.6, 1.3, 2, '18 13.4 9.6'), E(10.9, 6.6, 1.2, 1.9, '-14 10.9 6.6'), E(13.1, 6.6, 1.2, 1.9, '14 13.1 6.6'), E(12, 4.6, 1.2, 1.8)); },
    mint: function () { return [L(12, 19.4, 12, 11.4), P('M12 11.4c-4.4 0-6.4-2-6.4-5.2 3.8-.6 6.4 1.4 6.4 5.2z'), P('M12 11.4c4.4 0 6.4-2 6.4-5.2-3.8-.6-6.4 1.4-6.4 5.2z')]; },
    tea: function () { return [P('M6.4 17.6c0-5.8 4-9.8 11.2-10.6.4 7-4.4 11-11.2 10.6z'), L(6.4, 17.6, 15, 9.4), E(15.8, 15.4, 1.5, 2.4, '38 15.8 15.4')]; },
    green: function () { return [P('M12 19.4q-1.2-6.4-5.2-9.6'), P('M12 19.4q0-6.6 1.6-10.8'), P('M12 19.4q1.6-5.6 5.6-8')]; },
    /* Pine & Fir keeps the pine-eucalyptus handle until launch; eucalyptus took over the leafy branch */
    'pine-eucalyptus': function () { return [P('M12 3.6 7.6 9.4h2.6l-3.8 5.2h3.1L5.8 19.4h12.4l-3.7-4.8h3.1l-3.8-5.2h2.6z'), L(12, 19.4, 12, 21.2)]; },
    eucalyptus: function () { return join(P('M7.4 19q4.4-5.6 9.2-13.8'), C(9.2, 14.2, 2.1), C(13, 11.6, 2.1), C(15.4, 7.8, 2.1), C(12.4, 16.2, 2.1)); },

    /* ---- water ---- */
    fresh: function () { return [P('M4.8 9.4h9.6a2.2 2.2 0 1 0-2.2-2.2'), P('M4.8 13.4h11a2.2 2.2 0 1 1-2.2 2.2'), P('M4.8 17.4h6')]; },
    'marine-watery': function () { return [P('M4.8 14.6q3.6-2.6 7.2 0t7.2 0'), P('M4.8 18.2q3.6-2.6 7.2 0t7.2 0'), P('M12 4.4c1.9 2.5 2.9 4 2.9 5.4a2.9 2.9 0 1 1-5.8 0c0-1.4 1-2.9 2.9-5.4z')]; },

    /* ---- woods ---- */
    woody: function () { return [E(12, 12, 7, 6.2), E(12, 12, 4.3, 3.7), E(12, 12, 1.7, 1.4)]; },
    cedarwood: function () { return [P('M12 4.6 8 10.4h8z'), P('M12 9 7 15.4h10z'), L(12, 15.4, 12, 19.4)]; },
    sandalwood: function () { return [P('M6.2 9.4h11.6v5.2H6.2z'), P('M6.2 10.8q5.8 1.4 11.6 0'), P('M6.2 13.2q5.8-1.4 11.6 0'), E(6.2, 12, 1.1, 2.6)]; },
    patchouli: function () { return [L(12, 19.4, 12, 12.6), P('M12 12.6c-4 0-6-2.4-6-6 4-.8 6 1.6 6 6z'), P('M12 12.6c4 0 6-2.4 6-6-4-.8-6 1.6-6 6z'), L(9.2, 9.4, 12, 12.6)]; },
    earthy: function () { return join(P('M4.6 17.4q3.6-4 7.4 0t7.4 0'), P('M5.4 20q3.2-2.6 6.6 0t6.6 0'), L(12, 14.6, 12, 9.4), E(9.8, 10.2, 2.2, 1.4, '-30 9.8 10.2'), E(14.2, 11.6, 2.2, 1.4, '30 14.2 11.6')); },
    smoky: function () { return [P('M9.4 19.4c0-3.2 4.2-3.6 4.2-6.8S9.8 8 9.8 4.8'), P('M15 19.4c0-2.4 2.6-3 2.6-5.4')]; },
    leather: function () { return [P('M6.4 7.2h11.2a1.6 1.6 0 0 1 1.6 1.6v6.4a1.6 1.6 0 0 1-1.6 1.6H6.4a1.6 1.6 0 0 1-1.6-1.6V8.8a1.6 1.6 0 0 1 1.6-1.6z'), { t: 'line', a: mix({ x1: 7.6, y1: 10, x2: 16.4, y2: 10 }, dash('1.4 1.6')) }, { t: 'line', a: mix({ x1: 7.6, y1: 14, x2: 16.4, y2: 14 }, dash('1.4 1.6')) }]; },
    tobacco: function () { return [P('M5.6 18.4c0-6.4 4.6-11.4 12.8-12.4.6 7.8-4.6 12.8-12.8 12.4z'), L(5.6, 18.4, 14.6, 9.6), P('M9 15.4q2-2.6 4.6-4.2')]; },

    /* ---- amber, resin and spice ---- */
    amber: function () { return [P('M12 5.2 18 9v6l-6 3.8L6 15V9z'), L(6, 9, 12, 12.4), L(18, 9, 12, 12.4), L(12, 12.4, 12, 18.8)]; },
    'resin-resinous': function () { return [L(7.4, 4.8, 7.4, 19.2), P('M12.4 7.4c1.7 2.3 2.6 3.7 2.6 4.9a2.6 2.6 0 1 1-5.2 0c0-1.2.9-2.6 2.6-4.9z'), P('M17.4 13.6c1.2 1.7 1.9 2.7 1.9 3.5a1.9 1.9 0 1 1-3.8 0c0-.8.7-1.8 1.9-3.5z')]; },
    balsamic: function () { return [P('M12 4.8c3.2 4.2 5 6.8 5 9.2a5 5 0 1 1-10 0c0-2.4 1.8-5 5-9.2z'), P('M12 11.4c1.3 1.8 2 2.8 2 3.7a2 2 0 1 1-4 0c0-.9.7-1.9 2-3.7z')]; },
    musk: function () { return [C(12, 12, 2), C(12, 12, 4.6, dash('1.6 2')), C(12, 12, 7.2, dash('1.6 2.4'))]; },
    powdery: function () { return join(C(12, 13.4, 4.6), P('M8.6 10q3.4-2.6 6.8 0'), C(6.4, 7.4, 0.9), C(12, 5.6, 0.9), C(17.6, 7.4, 0.9)); },
    creamy: function () { return [P('M12 12a1.8 1.8 0 1 1 1.8 1.8A3.6 3.6 0 0 1 10.2 14a5.4 5.4 0 0 1 5.4-5.4 7.2 7.2 0 0 1 7.2 7.2'), P('M4.8 12a7.2 7.2 0 0 1 3.6-6.2')]; },
    solar: function () { return join(C(12, 12, 4.2), rays(8, 6, 8.4)); },
    warm: function () { return [P('M8.4 19.4c0-2.6 2.6-3 2.6-5.6s-2.6-3-2.6-5.6 2.6-3 2.6-5.6'), P('M15 19.4c0-2.6 2.6-3 2.6-5.6s-2.6-3-2.6-5.6')]; },
    vanilla: function () { return [E(10.2, 12, 2.4, 6.8, '-12 10.2 12'), E(14.4, 12.6, 2, 6, '14 14.4 12.6'), C(10.2, 10.6, 0.7), C(10.4, 13.6, 0.7)]; },
    'tonka-bean': function () { return [E(12, 12, 4, 6.4, '22 12 12'), P('M9.2 7.6q3.4 4.8 5 9.2')]; },
    spicy: function () { return [star(6, 7.2, 2.8), C(12, 12, 1.6)]; },
    cinnamon: function () { return [P('M7.2 8.2h9.6v7.6H7.2z'), E(7.2, 12, 1.4, 3.8), P('M7.2 12a1.4 3.8 0 0 1 2.4-3.4')]; },
    clove: function () { return join(C(12, 7.8, 2.3), L(12, 10.1, 12, 19.6), L(12, 10.1, 9, 12.4), L(12, 10.1, 15, 12.4)); },
    sweet: function () { return [P('M6.8 9.6 12 6.6l5.2 3-5.2 3z'), P('M6.8 9.6v5.8l5.2 3v-5.8'), P('M17.2 9.6v5.8l-5.2 3')]; },
    gourmand: function () { return [P('M7.4 12.6h9.2l-1.4 6.2H8.8z'), P('M8.2 12.6a3.8 3.8 0 0 1 7.6 0'), P('M12 8.8a1.6 1.6 0 1 1 1.6-1.6')]; },
    caramel: function () { return [P('M8.6 9.4h6.8a1.6 1.6 0 0 1 1.6 1.6v2a1.6 1.6 0 0 1-1.6 1.6H8.6A1.6 1.6 0 0 1 7 13v-2a1.6 1.6 0 0 1 1.6-1.6z'), P('M7 11 4.4 9.4v5.2L7 13'), P('M17 11l2.6-1.6v5.2L17 13')]; },
    maple: function () { return [P('M12 4.8l1.8 3.2 2.6-1-.8 2.8 3.4-.6-2.2 2.6 3 1.4-3 1.4 1.2 2.2-3.4-.4.4 2.6-2-1.6-2 1.6.4-2.6-3.4.4 1.2-2.2-3-1.4 3-1.4-2.2-2.6 3.4.6-.8-2.8 2.6 1z'), L(12, 19.4, 12, 15.6)]; },
    chocolate: function () { return [P('M6.6 7.8h10.8v8.4H6.6z'), L(12, 7.8, 12, 16.2), L(6.6, 12, 17.4, 12)]; },
    nutty: function () { return [E(9.6, 13.4, 3, 4.2, '-24 9.6 13.4'), E(14.6, 11.6, 2.6, 3.8, '20 14.6 11.6'), P('M8.2 10.6q1.6 3 2.4 5.8')]; },
    almond: function () { return [E(12, 12, 4, 6.4), P('M12 5.6q-2.2 6.4 0 12.8')]; },
    aldehydic: function () { return [star(4, 7.4, 2.2), C(17.6, 6.4, 1.4), C(6.4, 16.6, 1.1)]; }
  };

  /* the two merged notes keep their old handles for now; these keys keep their
     marks when the handles are renamed to white-florals and resinous */
  NOTE_MARK['white-florals'] = NOTE_MARK['jasmine-white-florals'];
  NOTE_MARK.resinous = NOTE_MARK['resin-resinous'];
  NOTE_MARK['pine-fir'] = NOTE_MARK['pine-eucalyptus'];

  /* facet-level shapes, used only when a note has no mark of its own */
  var FACET_MARK = {
    citrus: 'citrus', fruity: 'fruity', green: 'green', aromatic: 'herbal', water: 'marine-watery',
    floral: 'floral', 'soft-floral': 'powdery', 'floral-amber': 'neroli',
    'soft-amber': 'musk', amber: 'amber', 'woody-amber': 'sandalwood',
    woods: 'woody', 'mossy-woods': 'earthy', 'dry-woods': 'smoky'
  };
  function markFor(item) {
    var fn = NOTE_MARK[item.handle];
    if (!fn) fn = NOTE_MARK[FACET_MARK[(item.facet || '').replace(/\s+/g, '-')]];
    return fn ? fn() : NOTE_MARK.amber();
  }
  function drawGlyph(item, x, y, r) {
    var scale = (r * 1.62) / 24;
    var g = el('g', { 'class': 'eoc-scent-marker__glyph', transform: 'translate(' + f2(x) + ' ' + f2(y) + ') scale(' + f2(scale) + ') translate(-12 -12)' });
    markFor(item).forEach(function (s) { g.appendChild(el(s.t, s.a)); });
    return g;
  }

  var CLIP = 'eoc-scent-clip-circle';

  function ensureClip(svg) {
    if (svg.ownerDocument.getElementById(CLIP)) return;
    var d = el('defs');
    var cp = el('clipPath', { id: CLIP, clipPathUnits: 'objectBoundingBox' });
    cp.appendChild(el('circle', { cx: '.5', cy: '.5', r: '.5' }));
    d.appendChild(cp);
    svg.insertBefore(d, svg.firstChild);
  }

  function tooltip(host) {
    var tip = host.querySelector('.eoc-scent-tip');
    if (!tip) {
      tip = document.createElement('span');
      tip.className = 'eoc-scent-tip';
      tip.setAttribute('aria-hidden', 'true');
      host.appendChild(tip);
    }
    return {
      show: function (text, leftPct, topPct, sub) {
        tip.textContent = text;
        if (sub) {
          /* second line: says the mark is a link to another page */
          var s = document.createElement('span');
          s.textContent = sub;
          s.style.cssText = 'display:block;margin-top:3px;text-transform:none;letter-spacing:0.02em;font-size:12px;opacity:0.85;';
          tip.appendChild(s);
        }
        tip.style.left = leftPct + '%';
        tip.style.top = topPct + '%';
        tip.setAttribute('data-on', '1');
      },
      hide: function () { tip.removeAttribute('data-on'); }
    };
  }

  /* x,y in user units -> percentage of the rendered box, via the viewBox */
  function pct(svg, x, y) {
    var vb = (svg.getAttribute('viewBox') || '0 0 100 100').split(/[\s,]+/).map(Number);
    return [((x - vb[0]) / vb[2]) * 100, ((y - vb[1]) / vb[3]) * 100];
  }

  function label(item) {
    var bits = [item.name];
    if (item.facet) bits.push(item.facet.replace(/-/g, ' '));
    if (item.band) bits.push(item.band + ' note');
    return bits.join(' \u00b7 ');
  }

  /* Where clicking a note goes: the note's own page (/pages/scent-notes/<handle>)
     when the theme passes one in item.url - Liquid emits scent_note.system.url,
     which is blank until the definition has web pages turned on. Until then,
     storefront search on the note name (it over-matches: it reads descriptions). */
  function noteHref(item) {
    if (item.url) return item.url;
    return '/search?type=product&q=' + encodeURIComponent(item.name || '');
  }

  /* A note's hand-drawn mark on its own, for the scent note pages and the
     Scent Notes index: <svg viewBox="0 0 24 24" data-eoc-note-mark="vanilla"
     data-facet="amber"></svg> is filled in place, stroked in currentColor. */
  function drawMarks(root) {
    var els = (root || document).querySelectorAll('svg[data-eoc-note-mark]:not([data-rendered])');
    for (var i = 0; i < els.length; i++) {
      var s = els[i];
      var g = el('g', { fill: 'none', stroke: 'currentColor', 'stroke-width': '1.7', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' });
      markFor({ handle: s.getAttribute('data-eoc-note-mark'), facet: s.getAttribute('data-facet') || '' })
        .forEach(function (sh) { g.appendChild(el(sh.t, sh.a)); });
      s.appendChild(g);
      s.setAttribute('data-rendered', '1');
    }
  }

  function marker(svg, host, tip, item, x, y, r, color, onDark) {
    var a = el('a', {
      'class': 'eoc-scent-marker__link', href: noteHref(item),
      'aria-label': label(item) + ' - see every product with this note'
    });
    var g = el('g', {
      'class': 'eoc-scent-marker' + (item.img ? '' : ' eoc-scent-marker--plain') + (onDark ? ' eoc-scent-marker--on-dark' : ''),
      'data-facet': item.facet
    });
    a.appendChild(g);
    g.appendChild(el('circle', { 'class': 'eoc-scent-marker__disc', cx: f2(x), cy: f2(y), r: f2(r) }, 'fill:' + color + ';'));
    if (item.img) {
      /* a photograph wins when the note has one; nothing does yet */
      ensureClip(svg);
      g.appendChild(el('image', {
        'class': 'eoc-scent-marker__img', href: item.img, x: f2(x - r), y: f2(y - r),
        width: f2(r * 2), height: f2(r * 2), preserveAspectRatio: 'xMidYMid slice',
        'clip-path': 'url(#' + CLIP + ')'
      }));
    } else {
      g.appendChild(drawGlyph(item, x, y, r));
    }
    g.appendChild(el('circle', { 'class': 'eoc-scent-marker__ring', cx: f2(x), cy: f2(y), r: f2(r) }));
    var at = pct(svg, x, y - r);
    function on() { tip.show(label(item), at[0], at[1], item.url ? 'See every oil with this note →' : null); g.setAttribute('data-on', '1'); }
    function off() { tip.hide(); g.removeAttribute('data-on'); }
    g.addEventListener('mouseenter', on);
    a.addEventListener('focus', on);
    g.addEventListener('mouseleave', off);
    a.addEventListener('blur', off);
    return a;
  }

  /* wheel: notes sit on the facet ring, spread across their own segment */
  function wheelMarkers(svg, host, data, G, c) {
    if (!data.markers || !data.items || !data.items.length) return;
    var tip = tooltip(host), seats = {}, colors = {}, angle = {};
    data.families.forEach(function (f) {
      var step = 90 / f.facets.length;
      f.facets.forEach(function (x, j) {
        angle[x.handle] = [f.ring * 90 + step * j, step];
        colors[x.handle] = f.color;
      });
    });
    data.items.forEach(function (it) { seats[it.facet] = (seats[it.facet] || 0) + 1; });
    var used = {}, r = (G.fac[1] - G.fac[0]) / 2 - 2.5, ringR = (G.fac[0] + G.fac[1]) / 2;
    var frag = document.createDocumentFragment();
    data.items.forEach(function (it) {
      var a = angle[it.facet];
      if (!a) return;
      var n = seats[it.facet], i = used[it.facet] = (used[it.facet] || 0) + 1;
      var deg = a[0] + a[1] * ((i - 0.5) / n);
      var p = pt(c, c, ringR, deg);
      frag.appendChild(marker(svg, host, tip, it, p[0], p[1], Math.min(r, (a[1] / n) * 0.9), colors[it.facet] || '#926a3a'));
    });
    svg.appendChild(frag);
  }

  /* pyramid: notes sit in a row inside their band, within the trapezoid */
  var PYR_INK = '#4a3f36';
  var BANDS = {
    top:   { y: 72,  halfAt: function (y) { return 58.4 * (y / 104); } },
    heart: { y: 142, halfAt: function (y) { return 58.4 + (98.8 - 58.4) * ((y - 104) / 72); } },
    base:  { y: 220, halfAt: function (y) { return 98.8 + (146 - 98.8) * ((y - 176) / 84); } }
  };
  function pyramidMarkers(host) {
    if (host.getAttribute('data-rendered')) return;
    var svg = host.querySelector('svg'), data;
    try { data = JSON.parse(host.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!svg || !data || !data.items || !data.items.length) return;
    var tip = tooltip(host), frag = document.createDocumentFragment();
    ['top', 'heart', 'base'].forEach(function (band) {
      var rows = data.items.filter(function (x) { return x.band === band; });
      if (!rows.length) return;
      var B = BANDS[band], half = B.halfAt(B.y), span = half * 2 - 12;
      var r = Math.min(13, Math.max(7, (span / rows.length) / 2 - 2));
      var gap = rows.length > 1 ? Math.min(span - r * 2, (r * 2 + 4) * (rows.length - 1)) : 0;
      rows.forEach(function (it, i) {
        var x = 150 - gap / 2 + (rows.length > 1 ? (gap * i) / (rows.length - 1) : 0);
        /* the base band is the dark one, so its marks flip to white */
        frag.appendChild(marker(svg, host, tip, it, x, B.y, r, band === 'base' ? '#ffffff' : PYR_INK, band === 'base'));
      });
    });
    svg.appendChild(frag);
    host.setAttribute('data-rendered', '1');
  }
  function initPyramids() {
    var hosts = document.querySelectorAll('[data-eoc-scent-markers]');
    for (var i = 0; i < hosts.length; i++) pyramidMarkers(hosts[i]);
  }

  function render(host) {
    if (host.getAttribute('data-rendered')) return;
    var data, svg = host.querySelector('svg');
    try { data = JSON.parse(host.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!data || !svg || !data.families) return;
    var mode = data.mode === 'mini' ? 'mini' : 'labelled', G = GEOM[mode], c = G.c, cls = data.cls || 'eoc-scent-wheel';
    var w = weigh(data), weighted = w.max > 0;
    var frag = document.createDocumentFragment(), defs = el('defs'), petals = [], markMid = null, markTop = 0;
    var ro = mode === 'labelled' ? readout(svg, cls, data, w) : null;
    var hover = function (f, facet) { return ro ? { enter: ro.enter(f, facet), leave: ro.leave } : null; };

    /* family ring: opacity rises with the share of notes sitting in that family */
    data.families.forEach(function (f) {
      var a0 = f.ring * 90, op;
      if (weighted) {
        var share = w.famMax ? (w.fam[f.handle] || 0) / w.famMax : 0;
        op = G.ops.fam + (1 - G.ops.fam) * share;
      } else {
        op = f.handle === data.family ? 1 : G.ops.fam;
      }
      if (mode === 'labelled') {
        var bottom = f.ring === 1 || f.ring === 2;   /* lower half: Amber and Woody */
        defs.appendChild(el('path', { id: data.uid + '-lbl-' + f.handle, d: arcPath(c, c, bottom ? G.lblBottom : G.lbl, a0 + 6, a0 + 84, bottom) }));
      }
      var seg = el('path', { 'class': cls + '__family', d: ring(c, c, G.fam[0], G.fam[1], a0, a0 + 90) }, 'fill:' + f.color + ';fill-opacity:' + f2(op) + ';');
      frag.appendChild(mode === 'labelled' ? link('/collections/' + f.handle, f.label, seg, hover(f, null)) : seg);
    });

    /* facet ring: every segment drawn faint so the wheel still reads as a wheel,
       then a weighted petal over each facet this oil occupies */
    data.families.forEach(function (f) {
      var a0 = f.ring * 90, n = f.facets.length;
      if (!n) return;
      var step = 90 / n;
      f.facets.forEach(function (x, j) {
        var s0 = a0 + step * j, mid = s0 + step / 2;
        var href = '/collections/' + f.handle + '?filter.p.m.custom.scent_facet=' + x.handle, aria = f.label + ' · ' + x.label;
        var count = w.by[x.handle] || 0;
        var isBase = !weighted && f.handle === data.family && x.label === data.facet;

        var baseOp = weighted ? G.ops.other : (f.handle === data.family ? G.ops.same : G.ops.other);
        var seg = el('path', { 'class': cls + '__facet', 'data-facet': x.handle, d: ring(c, c, G.fac[0], G.fac[1], s0, s0 + step) }, 'fill:' + f.color + ';fill-opacity:' + baseOp + ';');
        frag.appendChild(mode === 'labelled' ? link(href, aria, seg, hover(f, x)) : seg);

        if (weighted && count > 0) {
          var share = count / w.max;
          var op = PETAL.minOpacity + (1 - PETAL.minOpacity) * share;
          var petal = el('path', { 'class': cls + '__facet ' + cls + '__facet--lit', 'data-facet': x.handle, d: ring(c, c, G.fac[0], G.fac[1], s0, s0 + step) }, 'fill:' + f.color + ';fill-opacity:' + f2(op) + ';');
          if (count > markTop) { markTop = count; markMid = mid; }
          petals.push(mode === 'labelled' ? link(href, aria, petal, hover(f, x)) : petal);
        } else if (isBase) {
          var litSeg = el('path', { 'class': cls + '__facet ' + cls + '__facet--lit', d: ring(c, c, G.fac[0], G.lit, s0, s0 + step) }, 'fill:' + f.color + ';');
          petals.push(mode === 'labelled' ? link(href, aria, litSeg, hover(f, x)) : litSeg);
        }
      });
    });
    petals.forEach(function (p) { frag.appendChild(p); });

    if (markMid != null) {
      var mp = pt(c, c, (G.fac[0] + G.fac[1]) / 2, markMid);
      frag.appendChild(el('circle', { 'class': cls + '__mark', cx: f2(mp[0]), cy: f2(mp[1]), r: mode === 'mini' ? 2.4 : 3.4 }));
    }
    if (mode === 'labelled') {
      frag.insertBefore(defs, frag.firstChild);
      data.families.forEach(function (f) {
        var strongest = weighted ? (w.fam[f.handle] || 0) === w.famMax && w.famMax > 0 : f.handle === data.family;
        var t = el('text', { 'class': cls + '__famlabel' }, 'fill:' + (strongest ? f.color : 'var(--sc-text-2)') + ';');
        var tp = el('textPath', { href: '#' + data.uid + '-lbl-' + f.handle, startOffset: '50%', 'text-anchor': 'middle' }, null, f.label);
        t.appendChild(tp); frag.appendChild(t);
      });
    }
    svg.insertBefore(frag, svg.firstChild); /* centre text stays last, so it sits on top */
    if (mode === 'labelled') wheelMarkers(svg, host, data, G, c);
    host.setAttribute('data-rendered', '1');
  }
  function init() {
    var hosts = document.querySelectorAll('[data-eoc-scent-wheel]');
    for (var i = 0; i < hosts.length; i++) render(hosts[i]);
    initPyramids();
    drawMarks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  /* collection filters / sort / pagination swap the grid via innerHTML (no scripts run), so draw any host that arrives later */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-eoc-scent-wheel')) render(n);
          var inner = n.querySelectorAll('[data-eoc-scent-wheel]');
          for (var m = 0; m < inner.length; m++) render(inner[m]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  window.eocScentWheel = { render: render, init: init, pyramid: pyramidMarkers, marks: drawMarks };
})();
